import Application from "../../Application";
import GetDocumentTypeVisibilityLevelInteractor from "../../documentTypes/interactors/GetDocumentTypeVisibilityLevelsInteractor";
import Constants from "../common/Constants";

export default class GetCaseDecisionTypeVisibilityLevelsInteractor {
  private application: Application;
  private getDocumentTypeVisibilityLevelInteractor: GetDocumentTypeVisibilityLevelInteractor;

  constructor({ application, getDocumentTypeVisibilityLevel }) {
    this.application = application;
    this.getDocumentTypeVisibilityLevelInteractor =
      getDocumentTypeVisibilityLevel;
  }

  execute(organisationId: number, caseDecisionTypeId: number) {
    return this.getDocumentTypeVisibilityLevelInteractor.execute(
      `${Constants.organisationsPath}/${organisationId}/${Constants.caseDecisionTypesPath}/${caseDecisionTypeId}`
    );
  }
}
